import { useQuery } from 'react-query';

import type { DocBundleItemDto } from '../../../../backend/src/matter/doc/dto/get-doc-bundle-items.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';
import type { FactFilters } from '@/types';

export const useGetFactBundleItems = ({
  matterId,
  subsetId,
  filters,
}: {
  matterId: string;
  subsetId: string;
  filters: FactFilters;
}) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery<DocBundleItemDto[]>(
    [QueryEntity.FactBundleItems, { matterId, subsetId, filters }],
    async () => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.POST, data: createFilterBody(filters) });
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/facts/bundle-items`,
        fetchConfig,
      );
      if (!response.ok) throw new Error(`Failed to load fact source documents (${response.status})`);
      return response.json();
    },
    { enabled: !!matterId && !!subsetId },
  );
};
